import { render, staticRenderFns } from "./DistrictRanking.vue?vue&type=template&id=dd938a1e&scoped=true"
import script from "./DistrictRanking.vue?vue&type=script&lang=js"
export * from "./DistrictRanking.vue?vue&type=script&lang=js"
import style0 from "./DistrictRanking.vue?vue&type=style&index=0&id=dd938a1e&prod&lang=scss"
import style1 from "./DistrictRanking.vue?vue&type=style&index=1&id=dd938a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd938a1e",
  null
  
)

export default component.exports